<template>
  <div style="width: 100%; height: 100%">
    <div class="tabs_box">
      <div :class="tabs_cut === 0 ? 'pitch' : ''" @click="tabs_cut = 0">
        车辆维修记录
      </div>
      <div></div>
      <div :class="tabs_cut === 1 ? 'pitch' : ''" @click="tabs_cut = 1">
        车辆检测记录
      </div>
    </div>
    <div class="container">
      <div class="search_box">
        <v-search :searchType="tabs_cut === 0 ? 'maintainRecord_0' : 'maintainRecord_1'"
          :limit="tabs_cut === 0 ? tableParams1.limit : tableParams2.limit"
          @searchParams="searchChange($event)"></v-search>
      </div>
      <div class="table_box" v-if="tabs_cut === 0">
        <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe>
          <el-table-column property="number" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="carNumber" label="车牌号码">
          </el-table-column>
          <el-table-column property="carColorStr" label="车牌颜色">
          </el-table-column>
          <el-table-column property="carServiceStr" label="车辆营运性质">
          </el-table-column>
          <el-table-column property="repairLong" label="维修时间（分）" sortable>
          </el-table-column>
          <el-table-column property="repairStateStr" label="状态">
          </el-table-column>
          <el-table-column property="repairTypeStr" label="维修类别">
          </el-table-column>
          <el-table-column label="操作" width="215" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goRedact(scope.row)" v-if="scope.row.repairState != 3">编辑</el-button>
              <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
              <el-button type="text" @click="goImage(scope.row, 1)" v-if="scope.row.repairState == 3">结算单</el-button>
              <el-button type="text" @click="goImage(scope.row, 2)" v-if="scope.row.repairState == 3">合格证</el-button>
              <!-- <el-button type="text" v-if="scope.row.repairState == 3"
                >打印</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <!--  :current-page="currentPage4" -->
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams1.limit" :current-page.sync="tableParams1.page"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

      <div class="table_box" v-if="tabs_cut === 1">
        <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe>
          <el-table-column property="number" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="carNumber" label="车牌号码">
          </el-table-column>
          <el-table-column property="carColor" label="车牌颜色">
          </el-table-column>
          <el-table-column property="detectCompany" label="检测单位名称">
          </el-table-column>
          <el-table-column property="detectTime" label="检测时间">
          </el-table-column>
          <el-table-column property="detectTypeStr" label="检测类型">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
              <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging_box">
          <!--  :current-page="currentPage4" -->
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams2.limit" :current-page.sync="tableParams2.page"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <v-addCarInspect :dialogShow.sync="addCarInspectShow"></v-addCarInspect>
    <v-detail-1 :dialogShow.sync="detailShow_1" :dialogData="detailData_1"></v-detail-1>
    <v-detail-2 :dialogShow.sync="detailShow_2" :dialogData="detailData_2"></v-detail-2>
    <v-detail-3 :dialogShow.sync="detailShow_3" :dialogData="detailData_3"></v-detail-3>
    <v-addCarMaintain :dialogShow.sync="addCarMaintainShow"></v-addCarMaintain>
    <v-detailCarMaintain :dialogShow.sync="detailCarMaintainShow"
      :dialogData="detailCarMaintainData"></v-detailCarMaintain>
    <v-redact-1 :dialogShow.sync="redactShow_1" :dialogData="redactData_1"></v-redact-1>
    <v-redact-2 :dialogShow.sync="redactShow_2" :dialogData="redactData_2"></v-redact-2>
    <v-jiesuandan :imgIndex="imgIndex" :dialogData="jiesuandanData" :dialogShow.sync="jiesuandanShow"></v-jiesuandan>
    <v-redactCarInspect :dialogShow.sync="redactCarInspectShow" :dialogData="redactCarInspectData"></v-redactCarInspect>
  </div>
</template>

<script>
import search from "@/components/search.vue";
import addCarInspect from "./maintainRecord_component/addCarInspect.vue";
import detail_1 from "./maintainRecord_component/detail_1.vue";
import detail_2 from "./maintainRecord_component/detail_2.vue";
import detail_3 from "./maintainRecord_component/detail_3.vue";
import addCarMaintain from "./maintainRecord_component/addCarMaintain.vue";
import detailCarMaintain from "./maintainRecord_component/detailCarMaintain.vue";
import redact_1 from "./maintainRecord_component/redact_1.vue";
import redact_2 from "./maintainRecord_component/redact_2.vue";
import jiesuandan from "./maintainRecord_component/jiesuandan.vue";
import redactCarInspect from "./maintainRecord_component/redactCarInspect.vue";
import { exportExcel } from "@/utils/util";
export default {
  name: "maintainRecord",
  data () {
    return {
      imgIndex: 1,
      tabs_cut: 0,
      tableData: [],
      tableParams1: {
        carNumber: null,
        carService: 0,
        endTimeStr: null,
        limit: 10,
        page: 1,
        repairCompanyName: null,
        repairState: 0,
        startTimeStr: null,
        isPage: true,
      },
      tableParams2: {
        carNumber: "",
        endTimeStr: "",
        limit: 10,
        page: 1,
        startTimeStr: "",
        isPage: true,
      },
      total: 0,
      tableLoading: false,
      addCarInspectShow: false,
      addCarMaintainShow: false,
      redactShow_1: false,
      redactData_1: {},
      redactShow_2: false,
      redactData_2: {},
      detailShow_1: false,
      detailData_1: {},
      detailShow_2: false,
      detailData_2: {},
      detailShow_3: false,
      detailData_3: {},
      jiesuandanShow: false,
      jiesuandanData: {},
      dimissionDilogShow: false,
      detailCarMaintainShow: false,
      detailCarMaintainData: {},
      detailData: {},
      dimissionDilogData: {},
      redactCarInspectShow: false,
      redactCarInspectData: {},
    };
  },
  components: {
    "v-search": search,
    "v-addCarInspect": addCarInspect,
    "v-detail-1": detail_1,
    "v-detail-2": detail_2,
    "v-detail-3": detail_3,
    "v-addCarMaintain": addCarMaintain,
    "v-detailCarMaintain": detailCarMaintain,
    "v-redact-1": redact_1,
    "v-redact-2": redact_2,
    "v-jiesuandan": jiesuandan,
    "v-redactCarInspect": redactCarInspect,
  },
  props: {},
  created () {
    this.getList();
  },
  watch: {
    tabs_cut (val) {
      // console.log(val);
      // if (val === 0 || val === 1) {
      this.getList();
      // }
    },
  },
  methods: {
    getList (data) {
      if (this.tabs_cut == 0) {
        this.tableParams1.isPage = true;
        let params = data ? data : this.tableParams1;
        this.tableLoading = true;
        this.$http.getRepairList(params).then((res) => {
          this.tableLoading = false;
          if (res.code === 0) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.error(res.msg);
          }
        });
      } else if (this.tabs_cut == 1) {
        this.tableParams2.isPage = true;
        let params = data ? data : this.tableParams2;
        this.tableLoading = true;
        this.$http.getDetectList(params).then((res) => {
          this.tableLoading = false;
          if (res.code === 0) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.tableData = [];
            this.total = 0;
            this.$message.info(res.msg);
          }
        });
      }
    },
    // 事件处理函数
    async searchChange (value) {
      if (this.tabs_cut == 0) {
        this.tableParams1 = value;
      } else {
        this.tableParams2 = value;
      }
    },
    handleSizeChange (val) {
      if (this.tabs_cut == 0) {
        this.tableParams1.limit = val;
        this.tableParams1.page = 1;
      } else {
        this.tableParams2.limit = val;
        this.tableParams2.page = 1;
      }
      this.getList();
    },
    handleCurrentChange (val) {
      if (this.tabs_cut == 0) {
        this.tableParams1.page = val;
      } else {
        this.tableParams2.page = val;
      }

      this.getList();
    },
    goRedact (row) {
      switch (this.tabs_cut) {
        case 0:
          if (row.repairState == 1) {
            this.redactData_1 = row;
            this.redactShow_1 = true;
          } else if (row.repairState == 2) {
            this.redactData_2 = row;
            this.redactShow_2 = true;
          }
          break;

        case 1:
          this.redactCarInspectData = row;
          this.redactCarInspectShow = true;
          break;
      }
    },
    goImage (row, index) {
      this.imgIndex = index;
      this.jiesuandanShow = true;
      this.jiesuandanData = row;
    },
    goDetail (row) {
      switch (this.tabs_cut) {
        case 0:
          if (row.repairState == 1) {
            this.detailData_1 = row;
            this.detailShow_1 = true;
          } else if (row.repairState == 2) {
            this.detailData_2 = row;
            this.detailShow_2 = true;
          } else {
            this.detailData_3 = row;
            this.detailShow_3 = true;
          }

          break;

        case 1:
          this.detailCarMaintainData = row;
          this.detailCarMaintainShow = true;
          break;
      }
    },
    goDimission (row) {
      this.dimissionDilogData = row;
      this.dimissionDilogShow = true;
    },
    addFunction () {
      switch (this.tabs_cut) {
        case 0:
          this.addCarMaintainShow = true;
          break;

        case 1:
          this.addCarInspectShow = true;
          break;
      }
    },
    handleClick (e) {
      console.log(e);
    },
    downloadExport () {
      switch (this.tabs_cut) {
        case 0:
          this.tableParams1.isPage = false;
          this.$http.getRepairList(this.tableParams1).then((res) => {
            if (res.code === 0) {
              const exportExcelList1 = res.data;
              // 表头
              const tHeader1 = [
                "序号",
                "车牌号码",
                "车牌颜色",
                "车辆营运性质",
                "维修时间（分）",
                "状态",
                "维修类别"
              ];
              // table表格中对应的属性名
              const filterVal1 = [
                "number",
                "carNumber",
                "carColorStr",
                "carServiceStr",
                "repairLong",
                "repairStateStr",
                "repairTypeStr"
              ];
              exportExcel(
                tHeader1,
                filterVal1,
                exportExcelList1,
                "车辆维修记录"
              );
            } else {
              this.$message.info(res.msg);
            }
          });
          break;

        case 1:
          this.tableParams2.isPage = false;
          this.$http.getDetectList(this.tableParams2).then((res) => {
            if (res.code === 0) {
              const exportExcelList2 = res.data;
              // 表头
              const tHeader2 = [
                "序号",
                "车牌号码",
                "车牌颜色",
                "检测单位名称",
                "检测时间",
                "检测类型",
              ];
              // table表格中对应的属性名
              const filterVal2 = [
                "number",
                "carNumber",
                "carColorStr",
                "detectCompany",
                "detectTime",
                "detectTypeStr",
              ];
              exportExcel(
                tHeader2,
                filterVal2,
                exportExcelList2,
                "车辆检测记录"
              );
            } else {
              this.$message.info(res.msg);
            }
          });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";

.tabs_box {
  width: 284px;
  height: 50px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #afafaf;
  padding: 0 23px;
  box-sizing: border-box;
  box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);

  >div:nth-child(2) {
    width: 1px;
    height: 16px;
    background-color: #e5e5e5;
    margin-top: 10px;
  }

  >div:nth-child(1),
  >div:nth-child(3) {
    cursor: pointer;
  }

  .pitch {
    color: #255A7E;
  }
}

.container {
  min-height: calc(100% - 50px);
  position: relative;
  top: -14px;
  left: 0;
  border-radius: 0 8px 8px 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord.vue